// extracted by mini-css-extract-plugin
export default {"wrapper":"iz-z","viewport":"jz-z","container":"kz-z","slide":"lz-z"};